import * as React from 'react'
import styles from './style.module.css';
import Button from '../../../../../../design-system/lib/Button';
import { Attach, AUTO_DISPATCH, calendar_gray, calendar_time_gray, CLOSE, COD, double_top, email_icon, hashtag2, INFO_CIRCLE, input, 
  list_gray, MAP, notes } from '../../../../../../assets';
import DropDown from '../../../../../../design-system/lib/DropDown';
import Modal from '../../../../../../design-system/lib/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { Add_Service_Option, ChangeNewTravelDialoge, Edit_Travel_Operate_Changed, NewOrder_Order_setCustomField, NewTravelResetReserve, New_Order_Reset_DropOff,
   New_Order_Reset_DropOffs, New_Order_Reset_Pickup, New_Travel_PaymentMethod, Remove_Service_Option, ResetNewOrder, SetCodAmount,
    SetNotesOrder, SetReferenceID, Set_Auto_ActiveVehicleType, Set_DropOff_Inputs, Set_NewOrder_OrderType, Set_Pickup_address, 
    Set_Service_ActiveVehicleType, Set_Service_DeliveryMethod, Set_newOrder_draft } from '../../../../../../Redux/actions/actionNames';
import { getCenterMap } from '../../../../../../helper/module';
import { GetVehicletypeByServiceAction } from '../../../../../../Redux/actions/actions';
import { useTranslation } from 'react-i18next';
import Input from '../../../../../../design-system/lib/Input';
 import Typography from '../../../../../../design-system/lib/Typography';
import { UseCRUDDropoffs } from '../../../../../../hooks/useCRUD_Dropoffs';
import Radiobutton from '../../../../../../design-system/lib/Radiobutton';
import CustomField_DropDown from '../../../../../../CustomFields/DropDown';
import Toggle from '../../../../../../design-system/lib/toggle';
import CustomField_Input from '../../../../../../CustomFields/Input';
import TooltipOnro from '../../../../../../design-system/lib/Tooltip';
import CustomField_Phone from '../../../../../../CustomFields/phone';
import CustomField_MultiLine from '../../../../../../CustomFields/multiLine';
import CustomField_Date from '../../../../../../CustomFields/Date';
import CustomField_DateTime from '../../../../../../CustomFields/DateTime';
import CustomField_file from '../../../../../../CustomFields/file';
 import jalali from "jalali-moment";
import { checkTimestamp, get_dateFormat, get_lang } from '../../../../../../helper/UserData/userdate';
import EllipisWithTooltip from '../../../../../../design-system/lib/ellipsis-with-tooltip';
import { isEmpty } from 'lodash';

 


function ServiceEditOrder() {
  const [dialoge, setDialoge] = React.useState(null);
  const [collapsed, setCollapsed] = React.useState(true);
   const orderData = useSelector((state) => state.ViewTravel.pureData)
  const [done, setDone] = React.useState(false);

   const activeVehicleType = useSelector((state) => state.ViewTravel.pureData.service)
  const serviceOrderTypes = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType ? state.NewOrder.newOrder.service.activeVehicleType.orderTypes : [])
  const options = useSelector((state) => state.NewOrder.newOrder.service.options)
  const serviceVehicleTypes = useSelector((state) => state.SharedData.services)
  const lang = useSelector((state) => state.LocalData.lang)
  const paymentMethod = useSelector((state) => state.NewOrder.newOrder.paymentMethod.paymentMethod)
  const paymentSide = useSelector((state) => state.NewOrder.newOrder.paymentMethod.paymentSide)
  const orderTypeActive = useSelector((state) => state.ViewTravel.pureData.type)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const activeDeliveryMethod = useSelector((state) => state.ViewTravel.pureData.deliveryMethod)
  let { items, sEtItems } = UseCRUDDropoffs()
  const intercomData = useSelector((state) => state.SharedData.settings?.intercomData)
  const draft = useSelector((state) => state.NewOrder.newOrder.draft)
  const REFREV = useSelector((state) => state.NewOrder.newOrder.referenceID)
  const notess = useSelector((state) => state.NewOrder.newOrder.notes)
  const customField = useSelector((state) => state.NewOrder.newOrder.customField)
  const customFieldDefinitions = useSelector((state) => state.ViewTravel.pureData.customFieldDefinitions)


      React.useEffect(() => {
         if(!isEmpty(orderData.customFields)){
          Object.keys(orderData.customFields).forEach((fieldKey) => {
                dispatch(NewOrder_Order_setCustomField({ key: fieldKey, value: orderData.customFields[fieldKey] }))
          })
         }
        dispatch(SetNotesOrder(orderData?.note))
        dispatch(SetReferenceID(orderData?.referenceId))


      setDone(true)
      }, [])



  function hasCustomFieldError(fieldKey, definitions, customField, t) {
    const field = definitions.find(f => f.key === fieldKey);
    if (!field) return false;

    const value = customField[field.key];
    const config = field.config;

    const isEmptyx =
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);

    if (!field.isRequired && isEmptyx) return false;

    if (field.isRequired && isEmptyx) {
      return false
    }
 
    // TEXT
    if (config.type === "singleLine" || config.type === "multiLine") {
      if (typeof value !== "string") {
        return t("custominvalid");
      }

      if (config.minLength && value.length < config.minLength ) {
        return t("customminLength", { min: config.minLength });
      }

      if (config.maxLength && value.length > config.maxLength ) {
        return t("custommaxLength", { max: config.maxLength });
      }

      if (config.pattern && !new RegExp(config.pattern).test(value)) {
        return t("custompattern");
      }
    }

    // EMAIL
    if (config.type === "email") {
      if (!/^\S+@\S+\.\S+$/.test(value)) {
        return t("customemail");
      }
    }

    // PHONE
    if (config.type === "phone") {
      if (value.toString().length < 7) {
        return t("customphone");
      }
    }

    // NUMBER
    if (config.type === "number") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });
      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }
    }

    // DECIMAL


    if (config.type === "decimalNumber") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });

      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }

      if (config.precision !== undefined) {
        const decimals = value.toString().split(".")[1];
        if (decimals && decimals.length > config.precision) {
          return t("customdecimalPrecision", { p: config.precision });
        }
      }
    }



    // SELECT
    if (config.type === "select") {
      const allowed = config.choices.map(c => c.key);
      if (!allowed.includes(value)) {
        return t("customselect");
      }
    }

    // FILE
    if (config.type === "file") {

      if (value.url) {

      } else {
        if (!(value instanceof File)) {
          return t("customfileInvalid");
        }

        const sizeMB = value.size / (1024 * 1024);
        if (sizeMB > config.maxSizeMB) {
          return t("customfileSize", { max: config.maxSizeMB });
        }

        if (
          config.allowedTypes?.length &&
          !config.allowedTypes.includes(value.type)
        ) {
          return t("customfileType");
        }
      }

    }

    // DATE
    if (config.type === "date" || config.type === "dateTime") {
      if (isNaN(new Date(value).getTime())) {
        return t("customdate");
      }
    }

    return false;
  }



  function renderCustomField(
    field,
    value,
    filterdcustomFieldDefinitions ,
    customField
  ) {
    switch (field.config.type) {
      case 'phone':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Phone   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  value={customField[field.key] || ""} hint={field?.label} inputType="number" onChange={(e) => {
    dispatch(Edit_Travel_Operate_Changed());

              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e }))

            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );

      case 'singleLine':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Input   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={customField[field.key] || ""} config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e }))
    dispatch(Edit_Travel_Operate_Changed());


            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );
      case 'email':

        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Input   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={customField[field.key] || ""} config={field.config} icon={email_icon} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e }))
    dispatch(Edit_Travel_Operate_Changed());


            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );


      case 'number':
      case 'decimalNumber':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Input   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={customField[field.key] || ""} config={field.config} icon={hashtag2} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e }))
    dispatch(Edit_Travel_Operate_Changed());


            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );

      case 'multiLine':
        return (
          <div className={styles.OptionsRow} style={{ height: "auto", alignItems: "start" }}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>   {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            {console.log("customField[field.key]" , hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t))} 
            <CustomField_MultiLine   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  value={customField[field.key] || ""} config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: e?.target.value }))
    dispatch(Edit_Travel_Operate_Changed());

            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>
        );

      case 'boolean':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ 
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
             }}>
              <EllipisWithTooltip>{field?.label}</EllipisWithTooltip> {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} 
                 {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
              </span>
            <Toggle isActive={customField[field.key] || false} setIsHover={(e) => {
              dispatch(NewOrder_Order_setCustomField({ key: field.key, value: !(customField[field.key] || false) }))
    dispatch(Edit_Travel_Operate_Changed());

            }} />
          </div>
        );

      case 'select':
        return (

          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
             }}>
              <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} 
                   {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
                </span>
            <CustomField_DropDown   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  icon={list_gray}
              ItemsList={ItemsList(field?.config?.choices.map((item) => { return { title: item.label, data: item, id: item.key } }), customField[field.key], (JOJO) => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: JOJO.id }))
    dispatch(Edit_Travel_Operate_Changed());


              })} textStyle={styles.DropDownTextStyle} size='Small' text={customField[field.key] ? customField[field.key] : field?.label} placement={'bottomStart'}
              data={field?.config?.choices} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: null }))
              }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 

          </div>

        );

      case 'date':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex",
              flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_Date icon={calendar_gray}
              textStyle={styles.DropDownTextStyle} size='Small'
              text={customField[field.key] ? jalali(new Date(customField[field.key])).locale(get_lang()).format(` ${get_dateFormat()}`) : field?.label}
              placement={'bottomStart'} requiredText={t("Required")} onChange={(JOJO) => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: JOJO }))
    dispatch(Edit_Travel_Operate_Changed());


              }}
              isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: null }))
              }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 


          </div>
        );

      case 'dateTime':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row",
              justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_DateTime icon={calendar_time_gray}
              textStyle={styles.DropDownTextStyle} size='Small' text={customField[field.key] ? jalali(new Date(customField[field.key])).locale(get_lang()).format(` ${checkTimestamp(new Date(customField[field.key]))}`) : field?.label}
              placement={'bottomStart'} requiredText={t("Required")}
              onChange={(JOJO) => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: JOJO }))
    dispatch(Edit_Travel_Operate_Changed());


              }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: null }))
              }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 


          </div>

        );

      case 'file':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip>
            </span>  {(field?.isRequired && !customField[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
              </TooltipOnro>}
            </span>
            <CustomField_file   error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  config={field.config} icon={Attach} inputType={"file"}
              textStyle={styles.DropDownTextStyle} size='Small' text={field?.label} placement={'bottomStart'}
              requiredText={t("Required")} onChange={(JOJO) => {
                dispatch(NewOrder_Order_setCustomField({ key: field.key, value: JOJO }))
    dispatch(Edit_Travel_Operate_Changed());


              }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} />

 


          </div>
        );


      default:
        return null;
    }
  }

 
  const booleanHandleactive = (OP) => {
    if (booleanOptionisSaved(OP)) {
      dispatch(Remove_Service_Option(OP.id))
    } else {
      dispatch(Add_Service_Option({
        id: OP.id,
        type: "boolean"
      }))
    }

  };


  const booleanOptionisSaved = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }



  const ListhandleSelectedItem = (OP, item) => {

    if (ListoptionisSaved(item)) {
      dispatch(Remove_Service_Option(item.id))
      dispatch(Add_Service_Option({
        name: item.name,
        id: item.id,
        item: OP,
        type: "list"
      }))
    } else {
      dispatch(Add_Service_Option({
        name: item.name,
        id: item.id,
        item: OP,
        type: "list"
      }))
    }


  };


  const ListoptionisSaved = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }

  const ListoptionText = (option) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === option.id;
    });
    if (booll) {
      return `${booll.item.title}`
    } else {
      return t("Select")
    }
  }


  const inputHandleactive = (OP) => {
    // if (inputOptionisSaved(OP) && String(e.target.value).trim().length == 0) {
    //   dispatch(Remove_Service_Option(OP.id))
    // } else {
    //   dispatch(Add_Service_Option({
    //     id:OP.id,
    //     inputValue:OP.inputValue,
    //     type:OP.type,
    //     update:inputOptionisSaved(OP)
    //   }))
    // }
    if (OP.inputValue) {
      dispatch(Add_Service_Option({
        id: OP.id,
        inputValue: OP.inputValue,
        type: OP.type,
        update: inputOptionisSaved(OP)
      }))
    }
  };


  const inputOptionisSaved = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }


  const inputoptionText = (option) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === option.id;
    });
    if (booll) {
      return `${option.title} : ${booll.inputValue}`
    } else {
      return false
    }
  }

  const getInputoptionValue = (option) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === option.id;
    });
    if (booll) {
      return booll.inputValue
    } else {
      return null
    }
  }

  const InputOptionHandle = React.useCallback(() => {

    if (String(dialoge.inputType).length > 0) {
      inputHandleactive(dialoge)
      setTimeout(() => {
        setDialoge(null)
      }, 100);
    }

  }, [dialoge]);


  const showRequirdalert = React.useCallback(() => {

     let yy = false;

    try {
      



      customFieldDefinitions.filter((item) => { return (item.stage == "orderCreation" && item.isRequired) }).forEach((item) => {
        if (!customField[item.key]) {
          [
            yy = true
          ]
        }
      })

      return (yy)
    } catch (error) {
      return false
    }



  }, [customField, customFieldDefinitions ]);

  const closeNewOrder = () => {
    dispatch(ChangeNewTravelDialoge());
    dispatch(ResetNewOrder())

  }


  function ItemsList(data, currentState, setCurrentState) {
    return (
      <div className={styles.itemsConatiner}>
        {data.map((item) => {
          return <div onClick={() => { setCurrentState(item) }}>
            <Radiobutton size="Small" state={(currentState == item.id || currentState == item.title) ? "checked" : "unchecked"} onClick={() => { }} />
            {item.icon && <img src={item.icon} />}
            <Typography weight={(currentState == item.id || currentState == item.title) ? 'Body_Middle_Bold' : 'Body_Middle_Regular'} textColor={'TextNormal'} text={item.title} className={(currentState == item.id || currentState == item.title) ? styles.dropItemchecked : styles.dropItemUnchecked} />

          </div>
        })}
      </div>
    )
  }


  return (
    <div className={styles.ServiceNewOrderContainer} style={{marginBottom:"4px"}}>


      <div className={styles.ServiceNewOrderSecondRow} style={{ gap: "8px" }}>
        <DropDown size='Small' ItemsList={null} text={activeVehicleType?.title} icon={activeVehicleType?.icon} className={styles.service} 
        placement='bottomEnd' data={[]} onClick={()=>{}} checkSelected="full" />
        {/* {((activeVehicleType && activeVehicleType.setting?.isReferenceIdActive) || ["PickupDelivery"].indexOf(orderTypeActive) > -1 ||
          (customFieldDefinitions ? customFieldDefinitions?.filter((item) => { return item.stage == "orderCreation" }).length > 0 : true)) &&
          <Button className={!collapsed && styles.arrowDown} icon={double_top} size={'Medium'} type='Secondary' requiredText='*'
           isRequired={showRequirdalert()} onClick={() => { setCollapsed(!collapsed) }} 
          style={{ paddingInlineStart: "auto", paddingInlineEnd: "auto", padding: "7px", width: "14px", height: "14px" }} />} */}

      </div>

      {(collapsed && done && ((activeVehicleType && activeVehicleType.setting?.isReferenceIdActive) ||  ["PickupDelivery"].indexOf(orderTypeActive) > -1 ||
          (customFieldDefinitions ? customFieldDefinitions?.filter((item) => { return item.stage == "orderCreation" }).length > 0 : true))) && <div className={styles.collapsed}>
        

  
        {((activeVehicleType && activeVehicleType.setting?.isReferenceIdActive) ||  ["PickupDelivery"].indexOf(orderTypeActive) > -1) && <div className={styles.titleOptionsRow} >
          <Typography text={t("Fields")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
        </div>}

      {(activeVehicleType && activeVehicleType.setting?.isReferenceIdActive) && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> {t("Ref ID")}

            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto"}} />
            </TooltipOnro>


          </span>
          <CustomField_Input icon={hashtag2} hint={t("Ref ID")} inputType="text" defvalue={REFREV} onChange={(e) => {
            dispatch(SetReferenceID(e ? e : ""))
    dispatch(Edit_Travel_Operate_Changed());

          }} />
        </div>}

 


        {(["PickupDelivery"].indexOf(orderTypeActive) > -1) && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> {t("Notes")}


          </span>
          <CustomField_Input icon={notes} hint={t("Notes")} inputType="text" defvalue={notess} onChange={(e) => {
            dispatch(SetNotesOrder(e ? e : ""))
    dispatch(Edit_Travel_Operate_Changed());

          }} />
        </div>}

        {(customFieldDefinitions && customFieldDefinitions?.filter((item) => { return item.stage == "orderCreation" }).length > 0) && <div className={styles.titleOptionsRow} >
          <Typography text={t("Custom")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
        </div>
        }

 


        {customFieldDefinitions?.filter((item) => { return item.stage == "orderCreation" }).map(field =>
          renderCustomField(field, "", customFieldDefinitions || [] , customField)
        )}
 

        
 
      </div>}


 
      {dialoge && <Modal ConfirmationOnClick={InputOptionHandle} onclose={() => { setDialoge(null) }} size='large' icon={CLOSE} title={dialoge.title} body={<div> <Input type={dialoge.inputType} placeHolder={dialoge.hint} value={dialoge.inputValue} onChange={(e) => {
        setDialoge({
          ...dialoge,
          inputValue: e.target.value
        })
      }} /> </div>} ConfirmationText={t("Savechanges")} footer={<><Button size={'Medium'} style={{ marginInlineEnd: "16px" }} type='Secondary' text={t("clear")} onClick={() => {
        dispatch(Remove_Service_Option(dialoge.id))
        setDialoge(null)
      }} /></>} />}

    </div>
  )
}

export default ServiceEditOrder